import React from "react";
import { cn } from "../lib/helpers";
import { responsiveTitle1, pageTitle, bodyTextBlock } from "./typography.module.css";

import styles from "./faq-list.module.css";
import PortableText from "./portableText";
import useToggleExpand from "../lib/useToggleExpand";

function FaqList(props) {
  const { title, questionsAndAnswers } = props;

  return (
    <div className={cn(styles.root)}>
      <div className={styles.content}>
        {title && <h2 className={cn(responsiveTitle1, pageTitle, styles.title)}>{title}</h2>}
        {questionsAndAnswers && (
          <ul className={styles.faqWrapper}>
            {questionsAndAnswers.map((item) => {
              const toggleButtonRef = React.createRef();
              const textWrapper = React.createRef();
              const textInner = React.createRef();
              const expanded = useToggleExpand(toggleButtonRef, textWrapper, textInner);

              return (
                <li className={styles.faqItem} key={item._key}>
                  <button className={styles.question} ref={toggleButtonRef}>
                    {item.question}
                    <span className={styles.expandIcon}>
                      {expanded ? (
                        <svg
                          className={styles.carrot}
                          viewBox="0 0 21 12"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-label="close"
                        >
                          <polyline points="1,11 10.5,1 20,11" fill="none" strokeLinecap="square" />
                        </svg>
                      ) : (
                        <svg
                          className={styles.plus}
                          viewBox="0 0 26 26"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-label="open"
                        >
                          <polygon points="26,12 14,12 14,0 12,0 12,12 0,12 0,14 12,14 12,26 14,26 14,14 26,14 " />
                        </svg>
                      )}
                    </span>
                  </button>
                  <div className={styles.answer} ref={textWrapper}>
                    <div className={cn(bodyTextBlock, styles.answerInner)} ref={textInner}>
                      <PortableText blocks={item.answer} />
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export default FaqList;
